<script setup lang="ts">
//vue
import { reactive, onMounted } from "vue";

//services
import * as clienteService from "@/services/clienteService";
import storeCliente from "@/utils/storeCliente";

import {f2dec, fdata, fdataHora} from "@/utils/funcoes";
import imgLogin from "@/assets/images/logoLogin.png";
import imgSemImagem from "@/assets/images/sem-imagem.gif";

const controle = reactive({
  dadosCliente: null as clienteService.DadosCliente | null,
  parceiros: [] as clienteService.Parceiro[],
  filtrosParceiros: {
      pesquisa: "",
      cidadeId: null as number | null,
      paginaAtual: 1,
      tamanhoPagina: 12
  } as clienteService.ClienteParceirosFiltros,
  totalParceiros: 0,
  categorias: [] as clienteService.Categoria[],
  cidades: [] as clienteService.Cidade[],
  ver: "" as string,
  status: "" as string,
  erro: "" as string
});

onMounted(() => {
    setTimeout(() => {
        buscarDadosCliente();
        buscarCategorias();
        buscarParceiros();
        buscarCidades();
    }, 1000);
});

function buscarDadosCliente() {
    // Lógica para buscar os dados do cliente
    console.log("Buscando dados do cliente...");
    controle.status = "Buscando dados do cliente...";
    clienteService.obterDados()
        .then((r) => {
            console.log("Dados do cliente:", r);
            controle.status = "";
            controle.dadosCliente = r;
        })
        .catch((error) => {
            console.error("Erro ao buscar dados do cliente:", error);
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
            setTimeout(() => {
                sair();
            }, 4000);
        });
}

function buscarCategorias() {
    // Lógica para buscar os parceiros do cliente
    console.log("Buscando categorias...");
    controle.status = "Buscando categorias...";
    clienteService.obterCategorias()
        .then((r) => {
            controle.status = "";
            controle.categorias = r;
        })
        .catch((error) => {
            console.error("Erro ao buscar categorias:", error);
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function buscarParceiros() {
    // Lógica para buscar os parceiros do cliente
    console.log("Buscando parceiros do cliente...");
    controle.status = "Buscando parceiros do cliente...";
    clienteService.obterParceiros(controle.filtrosParceiros)
        .then((r) => {
            console.log("Parceiros do cliente:", r);
            controle.status = "";
            controle.parceiros = r.dados;
            controle.totalParceiros = r.totalRegistros;
        })
        .catch((error) => {
            console.error("Erro ao buscar parceiros do cliente:", error);
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function buscarCidades() {
    // Lógica para buscar as cidades
    console.log("Buscando cidades...");
    controle.status = "Buscando cidades...";
    clienteService.obterCidades()
        .then((r) => {
            controle.status = "";
            controle.cidades = r;
        })
        .catch((error) => {
            console.error("Erro ao buscar cidades:", error);
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function sair() {
    // Lógica para sair da área do cliente
    controle.status = "Saindo...";
    console.log("Saindo da área do cliente...");
    localStorage.removeItem("clienteToken");
    storeCliente.token = "";
    window.location.reload();
}

</script>

<template>
    <div class="row mt-4">
        <div class="col-md-12 text-center">
            <img :src="imgLogin" alt="Logo" class="img-fluid img-logo mb-3" />
        </div>
    </div>

     <div class="row mt-4 mb-3">
        <div class="col-md-12">
            <h2>Área do Cliente</h2>
        </div>
    </div>


    <div class="row">
        <div class="col-md-12">
            Bem-vindo, {{ controle.dadosCliente ? controle.dadosCliente.cliente.nome : 'Cliente' }}!
        </div>
    </div>

   <div class="row">
        <div class="col-md-12">
            <h4 v-if="controle.erro == ''">{{ controle.status }}</h4>
            <h4 v-if="controle.erro != ''" class="text-danger">{{ controle.erro }}</h4>
        </div>
    </div>
        
    <div class="row" id="divHome" v-if="controle.ver== ''">
          <div class="col-md-2 col-6">
            <a class="botao-menu" @click="controle.ver = 'meusDados'">
                Meu Cadastro
                <i class="flaticon-user-3"></i>
            </a>
        </div>

        <div class="col-md-2 col-6">
            <a class="botao-menu" @click="controle.ver = 'meusDependentes'">
                Meus Dependentes
                <i class="flaticon-people"></i>
            </a>
        </div>

        <div class="col-md-2 col-6">
            <a class="botao-menu" @click="controle.ver = 'meusBoletos'">
                Meus Boletos
                <i class="flaticon-document"></i>
            </a>
        </div>
        
        <div class="col-md-2 col-6">
            <a class="botao-menu" @click="controle.ver = 'meusContratos'">
                Meus Contratos
               
            </a>
        </div>
        
          <div class="col-md-2 col-6" >
            <a class="botao-menu" @click="sair()">
                Sair
                 <i class="flaticon-right-arrow-1"></i>
                
            </a>
        </div>

    </div>

    <div class="row" id="divMeusDados" v-if="controle.ver == 'meusDados'">
        <div class="col-md-12">
            <h3>Meus Dados</h3>
        </div>
        <div class="col-md-12">
            
            <div> Nome: {{controle.dadosCliente?.cliente.nome}}</div>
            <div> CPF: {{controle.dadosCliente?.cliente.cpf}}</div>
            <div> RG: {{controle.dadosCliente?.cliente.rg}}</div>
            <div> RG Expedidor: {{controle.dadosCliente?.cliente.rgExpedidor}}</div>
            <div> Email: {{controle.dadosCliente?.cliente.email}}</div>
            <div> Telefone: {{controle.dadosCliente?.cliente.telefone}}</div>
            <div> Logradouro: {{controle.dadosCliente?.cliente.logradouro}}</div>
            <div> Número: {{controle.dadosCliente?.cliente.numero}}</div>
            <div> Bairro: {{controle.dadosCliente?.cliente.bairro}}</div>
            <div> CEP: {{controle.dadosCliente?.cliente.complemento}}</div>
            <div> Cidade: {{controle.dadosCliente?.cliente.cidade}}</div>
            <div> Estado: {{controle.dadosCliente?.cliente.estado}}</div>
            <div> CEP: {{controle.dadosCliente?.cliente.cep}}</div>
            <div> Data Nascimento: {{controle.dadosCliente?.cliente.dataNascimento}}</div>
            <div> Data Entrega Cartão: {{controle.dadosCliente?.cliente.dataEntregaCartao}}</div>
            <div> Nome Conjuge: {{controle.dadosCliente?.cliente.nomeConjuge}}</div>
            <div> CPF Conjuge: {{controle.dadosCliente?.cliente.cpfConjuge}}</div>
        </div>
        <div class="col-md-12 mt-3">
            <button class="btn btn-secondary btn-sm" @click="controle.ver = ''">Voltar</button>
        </div>
    </div>


    <div class="row" id="divMeusDependentes" v-if="controle.ver == 'meusDependentes'">
        <div class="col-md-12">
            <h3>Meus Dependentes</h3>
        </div>
        <div class="col-md-12">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Parentesco</th>
                        <th>Data Nascimento</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="dependente in controle.dadosCliente?.dependentes" :key="dependente.dependenteId">
                        <td>{{ dependente.nome }}</td>
                        <td>{{ dependente.parentesco }}</td>
                        <td>{{fdata(dependente.dataNascimento) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-12 mt-3">
            <button class="btn btn-secondary btn-sm" @click="controle.ver = ''">Voltar</button>
        </div>
    </div>

    <div class="row" id="divMeusContratos" v-if="controle.ver == 'meusContratos'">
        <div class="col-md-12">
            <h3>Meus Contratos</h3>
        </div>

        <div class="col-md-6" v-for="contrato in controle.dadosCliente?.contratos" :key="contrato.contratoId">
            <div class="card">
                <h5 class="card-header">{{ contrato.plano.nome }}</h5>
                <div class="card-body">
                    <h5 class="card-title">{{contrato.status.descricao }}</h5>
                    <p class="card-text">Inicio: {{ fdata(contrato.dataInicio) }}, Fim: {{ fdata(contrato.dataFim) }}</p>
                    <p class="card-text">Assinado em: {{fdataHora(contrato.dataAssinatura) }}</p>
                    <RouterLink :to="{ name: 'PainelClienteAssinarContrato', params: { contratoId: contrato.contratoId } }" class="btn btn-warning btn-sm me-1" v-if="contrato.dataAssinatura == null">Assinar</RouterLink>
                    <RouterLink :to="{ name: 'PainelClienteVerContrato', params: { contratoId: contrato.contratoId } }" class="btn btn-primary btn-sm">Ver</RouterLink>
                </div>
            </div>
        </div>

        <div class="col-md-12 mt-3">
            <button class="btn btn-secondary btn-sm" @click="controle.ver = ''">Voltar</button>
        </div>
    </div>

    <div class="row" id="divMeusBoletos" v-if="controle.ver == 'meusBoletos'">
        <div class="col-md-12">
            <h3>Meus Boletos</h3>
        </div>
        <div class="col-md-12" v-if="controle.dadosCliente?.boletos?.length > 0">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Parentesco</th>
                        <th>Data Nascimento</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="boleto in controle.dadosCliente?.boletos" :key="boleto.boletoId">
                        <td>{{ boleto.codigoBarras }}</td>
                        <td>{{ boleto.dataVencimento }}</td>
                        <td>{{ boleto.valorDocumento }}</td>
                        <td>{{fdata(boleto.dataDocumento) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

         <div class="col-md-12" >
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Parcela</th>
                        <th>Vencimento</th>
                        <th>Valor</th>
                        <th>Contrato ID</th>
                        <th>Referente</th>
                        <th>Pagamento</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="boleto in controle.dadosCliente?.mensalidades" :key="boleto.id">
                        <td>{{ boleto.parcela }}</td>
                        <td>{{ fdata(boleto.dataVencimento) }}</td>
                        <td>{{ f2dec(boleto.valor) }}</td>
                        <td>{{boleto.contratoId }}</td>
                        <td>{{boleto.referente }}</td>
                        <td> 
                            <div v-if="boleto.dataPagamento != null" class="text-primary">
                                {{fdata(boleto.dataPagamento) }} <i class='flaticon-check'></i>
                            </div> 
                            <div v-else class="text-danger">
                                Em aberto <i class='flaticon-close'></i>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-12 mt-3">
            <button class="btn btn-secondary btn-sm" @click="controle.ver = ''">Voltar</button>
        </div>
    </div>

    <div class="row mt-2 mb-2" id="divParceiros" v-if="controle.ver == '' ">
        <div class="col-md-12 mb-2">
            <h3>Parceiros</h3>
        </div>

        <div class="col-md-3 mb-2">
            <label><i class="flaticon-search"></i> Pesquisar </label>
            <input class="form-control form-control-sm" 
            v-model="controle.filtrosParceiros.pesquisa" 
            @input="buscarParceiros()"
            placeholder="Nome do parceiro">
        </div>

        <div class="col-md-3 mb-2">
             <label><i class="flaticon-search"></i> Categoria </label>
            <select class="form-select form-select-sm" v-model="controle.filtrosParceiros.categoriaId" @change="buscarParceiros()">
                <option :value="null">- Todas Categorias - </option>
                <option v-for="categoria in controle.categorias" :key="categoria.categoriaId" :value="categoria.categoriaId">
                    {{ categoria.descricao }}
                </option>
            </select>
        </div>

        <div class="col-md-3 mb-2">
             <label><i class="flaticon-marker"></i> Cidade </label>
            <select class="form-select form-select-sm" v-model="controle.filtrosParceiros.cidadeId" @change="buscarParceiros()">
                <option :value="null">- Todas Cidades - </option>
                <option v-for="cidade in controle.cidades" :key="cidade.cidadeId" :value="cidade.cidadeId">
                    {{ cidade.nome }} - {{ cidade.estado }}
                </option>
            </select>
        </div>
        
        <div class="col-md-3">
            <a class="btn btn-primary btn-sm mb-2 mt-4">
                Ver todos
            </a>
        </div>

        <div class="col-md-3" v-for="parceiro in controle.parceiros" :key="parceiro.parceiroId">
            <div class="card mb-3" >
                 <img :src="imgSemImagem" class="card-img-top" alt="...">
                <div class="card-body">
                    <h6 class="card-title fw-bold">{{ parceiro.nome }}</h6>
                    <p class="card-text endereco mb-0"> {{parceiro.logradouro != null ? parceiro.logradouro + ' ' + parceiro.numero + ' - ' : ''}} {{ parceiro.bairro }} - {{ parceiro.cidade.nome }} - {{ parceiro.cidade.estado }}</p>
                    <p class="card-text mb-0" title="Telefone" ><i class="flaticon-phone-call"></i> {{parceiro.telefone}}</p>
                    <RouterLink :to="{ name: 'PainelClienteParceiro', params: { parceiroId: parceiro.parceiroId } }" class="btn btn-primary btn-sm text-center">Ver</RouterLink>
                </div>
            </div>
        </div>

        <div v-if="controle.parceiros.length == 0">
            <div class="col-md-12">
                Nenhum parceiro encontrado.
            </div>
        </div>
    </div>


</template>


<style lang="css" scoped>

    .botao-menu {
        background-color: white;
        border-radius: 5px;
        padding: 15px;
        height: 150px;
        font-size: 18px;
        text-align: center;
        color: black;
        font-style: normal;
        margin-bottom: 15px;
        text-decoration: none;
        display: block;
        cursor: pointer;
    }

    .botao-menu i {
        font-size: 40px;
        margin-top: 10px;
        display: block;
    }

    .img-logo {
        max-width: 200px;
    }

    
    .card-title {
        height: 40px;
    }

    .endereco {
        height: 40px;
    }
</style>